import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { getAllVendor, payToVandor } from "./vendor_halper";
import { Alert, Autocomplete, Backdrop, Box, Button, CircularProgress, Grid, Paper, TextField, Typography } from "@mui/material";
import { dateUsaToTimestamp, getCurrentDate } from "../frames/common";
import { validPrice } from "../booking/booking_halper";

const cu_date = getCurrentDate();
const refrance = ["Purchase", "Refund", "Salary", "Rent", "Transport Expanse", "Booking"]

function PayVendor() {
    const [vendorList, setVendorList] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [inputErrors, setInputErrors] = useState({});
    const [alertMessage, setAlertMessage] = useState(null);


    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const initData = async (auth) => {
        if (!auth) return;
        try {
            setVendorList(await getAllVendor());
        } catch (err) {
            console.error(err);
        }
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const date = dateUsaToTimestamp(data.get("date"));
        const amount = Number(data.get("amount"));
        const vendor = data.get("vendor");
        const reference = data.get("reference");
        const description = data.get("description");

        var flag = true;
        if (__error_handler(validPrice(amount) && amount !== 0, "amount", "Please fill a valid amount.")) {
            flag = false;
        }
        if (__error_handler(vendor !== "", "vendor", "Please select a vandor.")) {
            flag = false;
        }
        if (__error_handler(reference !== "", "reference", "Please select payment catagory.")) {
            flag = false;
        }
        if (__error_handler(description.length > 3, "description", "Please explain the transaction.")) {
            flag = false;
        }

        if (flag) {
            const _json = {
                "date": date, "amount": amount, "vendor": vendor, "reference": reference, "description": description,
            };
            setIsLoading(true);
            payToVandor(_json).then((_) => {
                setAlertMessage({ severity: "success", message: `The payment of ₹${amount} is raised succefully.` });
                event.target.reset();
                setIsLoading(false);
            }).catch((err) => {
                setAlertMessage({ severity: "error", message: err['message'] });
                setIsLoading(false);
            });
        }
    }

    const validateInputs = (event) => {
        return true;
    }

    return (
        <MenuFrame permission="VENDOR" onInit={initData} screen={"VENDOR_PAY"}>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Typography variant="h5">Payment to Vendor</Typography>
                    </Grid>
                    {alertMessage === null ? "" :
                        <Grid size={12}>
                            <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                        </Grid>
                    }
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="date" type="date" fullWidth error={inputErrors.date} defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2024-04-01" } }} helperText={inputErrors.date} placeholder="Date" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                        <Autocomplete
                            disablePortal
                            options={vendorList}
                            getOptionLabel={(option) => option.vendor_id}
                            renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <Box key={key} component="li" {...optionProps} >
                                        <Typography variant="body2">{option.name} <small>({option.vendor_id})</small></Typography>
                                    </Box>
                                );
                            }}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="vendor" fullWidth error={inputErrors.vendor} type="text" helperText={inputErrors.vendor} placeholder="Vendor" label="Vendor ID" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Autocomplete
                            disablePortal
                            options={refrance}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="reference" fullWidth error={inputErrors.reference} type="text" helperText={inputErrors.reference} placeholder="Category" label="Category" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                        <TextField variant="outlined" name="amount" type="number" fullWidth error={inputErrors.amount} slotProps={{ htmlInput: { max: 99999999, min: 0, step: 0.01 } }} helperText={inputErrors.amount} placeholder="₹" label="Amount Paid" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <TextField variant="outlined" name="description" type="text" fullWidth multiline rows={3} error={inputErrors.description} helperText={inputErrors.description} placeholder="Explain for what purpose this payment was done." label="Description" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                    </Grid>
                </Grid>
            </Box>
        </MenuFrame>
    );
}

export default PayVendor;
